import React from 'react';
import { SectionHeader } from './section-header';

export const DetailSection = (props: { title: string; children: React.ReactNode }) => {
  return (
    <>
      <SectionHeader title={props.title} />
      <div className='px-3 grid grid-cols-1 xl:grid-cols-2 2xl:grid-cols-3 bg-white gap-x-4'>{props.children}</div>
    </>
  );
};
